module.exports = __webpack_public_path__ + "static/media/badge_village.569fe3be.png";